import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import indexRoutes from "routes/index.jsx";
import { Provider } from "react-redux";
import store from "./store";
import { ApolloClient } from "apollo-client";
import { createHttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloProvider } from "react-apollo";

import { createMuiTheme, MuiThemeProvider } from "@material-ui/core";
import "assets/scss/material-dashboard-pro-react.css?v=1.2.0";
import "index.css";
import { GetUserKey, GetUserToken } from "helpers/UserHelper";
import { createCustomDateString1 } from "helpers/DateHelpers";

import { onError } from "apollo-link-error";
import * as Sentry from "@sentry/browser";
Sentry.init({
  dsn: "https://caabdd4285d44278afd12fc7691cc3d2@sentry.io/1330570",
  defaultIntegrations: false
});

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#555270",
      light: "#827e9e",
      dark: "#2b2a45"
    },
    secondary: {
      main: "#6c5cab",
      light: "#9d89dd",
      dark: "#3d327b"
    },
    grey: {
      main: "#607d8b",
      light: "#8eacbb",
      dark: "#34515e"
    }
  }
});

const hist = createBrowserHistory();

const logToSentry = true;

const sendToLogger = graphQLErrors => {
  Sentry.withScope(scope => {
    var token = GetUserToken();
    if (token && token.trim() !== "") {
      scope.setUser({
        Email: GetUserKey("userEmail"),
        Name: GetUserKey("name"),
        Surname: GetUserKey("surname"),
        UserId: GetUserKey("userID")
      });
    }

    scope.setTag("ErrorType", "GraphQL");
    scope.setTag("Platform", "Web");

    scope.setLevel("fatal");
    scope.setExtra("Errors:", graphQLErrors);
    scope.setExtra("Url:", window.location.href);

    var now = createCustomDateString1();
    Sentry.captureException(`GraphqlError ${now}`);
  });
};

const requestLink = createHttpLink({ uri: "http://rhlm.co.za/api/graphql" });

const errorLink = onError(({ networkError, graphQLErrors }) => {
  if (logToSentry) {
    if (graphQLErrors) sendToLogger(graphQLErrors);
  }
});

const link = errorLink.concat(requestLink);

const client = new ApolloClient({
  link,
  cache: new InMemoryCache()
});

ReactDOM.render(
  <Provider store={store}>
    <ApolloProvider client={client}>
      <MuiThemeProvider theme={theme}>
        <Router history={hist}>
          <Switch>
            {indexRoutes.map((prop, key) => {
              return (
                <Route path={prop.path} component={prop.component} key={key} />
              );
            })}
          </Switch>
        </Router>
      </MuiThemeProvider>
    </ApolloProvider>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js